import { Alert, Box, Button, CardContent, CircularProgress, Skeleton } from "@mui/material"
import { useArchivos } from "../hooks/useArchivos"
import CardActions from "src/pages/sistema/components/CardActions";
import { QueryStatus } from "src/types"
import { useEffect, useState } from "react"
import { ICON_MAS } from "src/pages/sistema/components/SharedIcons"
import { DialogNuevoArchivo } from "./DialogNuevoArchivo"
import { Documentacion } from "src/pages/sistema/components/Documentacion";

export const SeccionDocumentacion = ({ idOperacion, idPais, codSistema }: { idOperacion: number, idPais: number, codSistema: number }) => {

    const { archivos, status, refetch } = useArchivos(idOperacion, codSistema)

    const [openDialog, setOpenDialog] = useState<boolean>(false);

    useEffect(() => {
        if (!openDialog) refetch()
    }, [openDialog])



    // TODO: algun componente general para representar a un archivo
    return (
        <CardActions
            title="Documentos"
            actions={
                <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
                    Nuevo
                </Button>
            }
        >
            <CardContent>
                {
                    status === QueryStatus.Loading ?
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress disableShrink sx={{ mt: 6 }} />
                        </Box> :
                        status === QueryStatus.Error ?
                            <Alert severity='error'>Se produjo un error al cargar los archivos.</Alert> :
                            (!archivos || !archivos.length) ?
                                <Alert severity='info'>Todavía no hay ningún archivo.</Alert> :
                                <Documentacion
                                    archivos={archivos}
                                    refetch={refetch}
                                />
                }
            </CardContent>
            {
                openDialog &&
                <DialogNuevoArchivo
                    open={openDialog}
                    setOpen={setOpenDialog}
                    idOperacion={idOperacion}
                    idPais={idPais}
                    codSistema={codSistema}
                />
            }
        </CardActions>
    )
}
